import { IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';

export function getSecurityOptions(): IDropdownOption[] {
    return [
        {
            key: 'None',
            text: 'None',
        },
        {
            key: 'Ssl',
            text: 'SSL',
        },
        {
            key: 'Tls',
            text: 'TLS',
        },
    ];
}
